// translations/userManagement.ts
export const translations = {
    en: {
      'pricing.title': 'Simple,',
      'pricing.titleHighlight': 'Transparent Pricing',
      'pricing.subtitle': 'Start with a 3-day trial period when you register',
      'pricing.annual': 'Annual Plan',
      'pricing.save': 'Save 50%',
      'pricing.monthlyPrice': '€20/month',
      'pricing.originalPrice': '12.50€/month',
      'pricing.yearlyOriginal': 'Billed annually at 150€/year',
      'pricing.yearlyDiscount': 'Now only 75€/year with START50',
      'pricing.launchOffer': '🚀 Special Launch Offer',
      'pricing.launchDesc': 'Get 50% off with code',
      'pricing.launchLimit': 'Limited to first 50 customers',
      'pricing.launchCode': 'START50',
      'pricing.features': [
        'Unlimited invoice conversions',
        'Best value for regular use',
        'Cancel anytime'
      ],
      'pricing.cta': 'Start free trial now',
      'pricing.currentCredits': 'Current Credits', // Note: This seems like a Profile key, but keeping under pricing as per original structure grouping.
      'pricing.features.0': 'Unlimited invoice conversions', // Redundant with array above, included for completeness
      'pricing.features.1': 'Best value for regular use',   // Redundant with array above, included for completeness
      'pricing.features.2': 'Cancel anytime',               // Redundant with array above, included for completeness
      'pricing.buyCredits': 'Buy Credits',
      'pricing.buyCreditDescription': 'Need just one conversion? No subscription and 100% money back guarantee.',
      'pricing.buyCreditAction': 'Buy 1 Credit (5€)',
      'pricing.creditPurchaseSuccessBody': 'Your credit has been added to your account.',
      'pricing.creditPurchaseCanceledBody': 'Purchase canceled - you have not been charged.',
      'pricing.subscriptionNeeded': 'Please upgrade your account to continue converting files.',
  
      'subscription.creditsOrSubscription': 'Upgrade Required',
      'subscription.creditsOrSubscriptionMessage': 'To continue converting files, please upgrade to our premium plan or purchase credits.',
      'subscription.upgradeAction': 'Upgrade Now',
  
      'profile.credits': 'Available Credits',
      'profile.buyCreditButton': 'Buy Credits',
      'profile.daysLeft': 'days left',
      'profile.trialSubscription': 'Trial Active',
      'profile.unlimitedButton': 'Get Unlimited Access',
      'profile.title': 'Profile',
      'profile.email': 'Email',
      'profile.subscriptionStatus': 'Subscription Status',
      'profile.trialPeriod': 'Trial Period',
      'profile.activeSubscription': 'Active Subscription',
      'profile.noSubscription': 'No Active Subscription',
      'profile.creditsRemaining': '{{count}} credits',
      'profile.manageSubscription': 'Manage Subscription',
      'profile.manageSubscriptionButton': 'Manage Subscription & Invoices',
      'profile.signOut': 'Sign Out',
      'profile.features': 'Features',
      'profile.pdfToXRechnungDesc': 'Convert your PDF invoice to XML/XRechnung',
      'profile.pdfToZugferdDesc': 'Convert PDF invoices to ZUGFeRD hybrid format for seamless B2B transactions',
      'profile.xrechnungToPdfDesc': 'Convert your XRechnung XML invoice to a PDF',
      'profile.xrechnungViewerDesc': 'View your XRechnung XML invoices',
      'profile.welcomeMessage': 'Manage your account, your past invoices, and explore all available Invoice-Converter.com features.',
      'profile.featuresDescription': 'Explore all available invoice conversion tools designed to streamline your business processes.',
      'profile.creditsRemainingShort': 'credits remaining',
      'profile.refreshCredits': 'Refresh credits',
      'profile.benefit1': 'Unlimited conversions',
      'profile.benefit2': 'XRechnung, UBL, CII, & ZUGFeRD support',
      'profile.benefit3': 'Advanced features',
      'profile.upgradePlan': 'Upgrade Your Plan',
      'profile.upgradePlanDesc': 'Get unlimited access to all features with our Premium Plan.',
      'profile.usage': 'Your Usage',
      'profile.conversionsThisMonth': 'Conversions This Month',
      'profile.unlimited': 'Unlimited',
      'profile.plan': 'Plan',
      'profile.premium': 'Premium',
      'profile.nextBillingDate': 'Next Billing Date',
      'profile.monthly': 'Monthly',
  
      'auth.signin': 'Sign In',
      'auth.signup': 'Register',
      'auth.signingIn': 'Signing in...',
      'auth.emailPlaceholder': 'Email address',
      'auth.passwordPlaceholder': 'Password (min 6 characters)',
      'auth.confirmPasswordPlaceholder': 'Confirm Password',
      'auth.errors.passwordLength': 'Password must be at least 6 characters',
      'auth.errors.invalidCredentials': 'Invalid email or password',
      'auth.errors.generic': 'Failed to sign in',
      'auth.verificationSuccess': 'Email verification successful!',
      'auth.redirectingToSignIn': 'Redirecting to sign in...',
      'auth.processing': 'Processing authentication...',
      'auth.tooManyRequests': 'Too many requests. Please wait a few minutes before trying again.',
      'auth.termsCheckbox': 'I accept the',
      'auth.termsRequired': 'You must accept the General Terms and Conditions and Privacy Policy to register',
      'auth.accountConsentNotice': 'By creating an account, you agree to receive important service updates and relevant marketing communications. You can opt out of marketing emails at any time.',
      'auth.dpaCheckbox': 'I accept the', // Added for consistency if needed later
      'auth.dpaRequired': 'You must accept the Data Processing Agreement to register',
      'auth.noAccount': "Don't have an account?",
      'auth.haveAccount': 'Already have an account?',
      'auth.signingUp': 'Signing up...', 
      'auth.resetPassword': 'Reset Password',
      'auth.forgotPassword': 'I forgot my password',
      'auth.resetPasswordEmailSent': 'Please check your email to verify your account',
      'auth.resetPasswordError': 'Error sending password reset email',
      'auth.sending': 'Sending...',
      'auth.sendResetLink': 'Send Reset Link',
      'auth.backToSignIn': 'Back to Sign In',
      'auth.updatePassword': 'Update Password',
      'auth.newPassword': 'New Password',
      'auth.passwordUpdateSuccess': 'Password updated successfully!',
      'auth.passwordUpdateError': 'Error updating password',
      'auth.updating': 'Updating...',
      'auth.verificationEmailSent': 'Please check your email to verify your account',
      'auth.checkSpamFolder': 'If you don\'t see the email, please check your spam folder',
      'auth.passwordsDoNotMatch': 'Passwords do not match',
      'auth.emailConfirmedPopup': 'Your email has been confirmed! You can now sign in.',

      'errors.insufficientCreditsOrSubscription': 'Insufficient credits or subscription',
      'errors.creditDeductionFailed': 'Credit deduction failed',
      'errors.creditPurchaseProcessingFailed': 'Credit purchase processing failed',
    },
    de: {
      'pricing.title': 'Einfache,',
      'pricing.titleHighlight': 'transparente Preise',
      'pricing.subtitle': 'Starten Sie mit einer 3-tägigen Testphase bei der Registrierung',
      'pricing.annual': 'Jahresplan',
      'pricing.save': '50% sparen',
      'pricing.monthlyPrice': '20€/Monat',
      'pricing.originalPrice': '12.5€/Monat',
      'pricing.yearlyOriginal': 'Jährlich abgerechnet mit 150€/Jahr',
      'pricing.yearlyDiscount': 'Jetzt nur 75€/Jahr mit START50',
      'pricing.launchOffer': '🚀 Sonderangebot zum Start',
      'pricing.launchDesc': '50% Rabatt mit Code',
      'pricing.launchLimit': 'Limitiert auf die ersten 50 Kunden',
      'pricing.launchCode': 'START50',
      'pricing.features': [
        'Unbegrenzte Rechnungskonvertierungen',
        'Bestes Preis-Leistungs-Verhältnis für regelmäßige Nutzung',
        'Jederzeit kündbar'
      ],
      'pricing.cta': 'Kostenlose Testphase starten',
      'pricing.currentCredits': 'Aktuelle Credits',
      'pricing.features.0': 'Unbegrenzte Rechnungskonvertierungen',
      'pricing.features.1': 'Bestes Preis-Leistungs-Verhältnis für regelmäßige Nutzung',
      'pricing.features.2': 'Jederzeit kündbar',
      'pricing.buyCredits': 'Credits kaufen',
      'pricing.buyCreditDescription': 'Nur eine Konvertierung nötig? Kaufen Sie einen Credit ohne Abonnement - 100% Geld-Zurück-Garantie.',
      'pricing.buyCreditAction': '1 Credit kaufen (5€)',
      'pricing.creditPurchaseSuccessBody': 'Dein Credit wurde deinem Konto gutgeschrieben.',
      'pricing.creditPurchaseCanceledBody': 'Kauf abgebrochen – es wurde nichts berechnet.',
      'pricing.subscriptionNeeded': 'Bitte upgraden Sie Ihr Konto, um weitere Dateien zu konvertieren.',
  
      'subscription.creditsOrSubscription': 'Upgrade erforderlich',
      'subscription.creditsOrSubscriptionMessage': 'Um weiterhin Dateien zu konvertieren, upgraden Sie bitte auf unseren Premium-Plan oder kaufen Sie Credits.',
      'subscription.upgradeAction': 'Jetzt upgraden',
  
      'profile.credits': 'Verfügbare Credits',
      'profile.buyCreditButton': 'Credits kaufen',
      'profile.daysLeft': 'Tage übrig',
      'profile.trialSubscription': 'Testzeitraum aktiv',
      'profile.unlimitedButton': 'Unbegrenzten Zugang erhalten',
      'profile.title': 'Profil',
      'profile.email': 'E-Mail',
      'profile.subscriptionStatus': 'Abonnement-Status',
      'profile.trialPeriod': 'Testphase',
      'profile.activeSubscription': 'Aktives Abonnement',
      'profile.noSubscription': 'Kein aktives Abonnement',
      'profile.creditsRemaining': '{{count}} Guthaben',
      'profile.manageSubscription': 'Abonnement verwalten',
      'profile.manageSubscriptionButton': 'Abonnement & Rechnungen verwalten',
      'profile.signOut': 'Abmelden',
      'profile.features': 'Funktionen',
      'profile.pdfToXRechnungDesc': 'Konvertieren Sie Ihre PDF-Rechnung in XML/XRechnung',
      'profile.pdfToZugferdDesc': 'Konvertieren Sie PDF-Rechnungen in das ZUGFeRD-Hybridformat für nahtlose B2B-Transaktionen',
      'profile.xrechnungToPdfDesc': 'Konvertieren Sie Ihre XRechnung XML-Rechnung in eine übersichtliche PDF',
      'profile.xrechnungViewerDesc': 'Zeigen Sie Ihre XRechnung XML-Rechnungen übersichtlich an',
      'profile.welcomeMessage': 'Verwalten Sie Ihr Konto, Ihre vergangenen Rechnungen und erkunden Sie alle verfügbaren Invoice-Converter.com Funktionen.',
      'profile.featuresDescription': 'Entdecken Sie alle verfügbaren Rechnungskonvertierungstools, die darauf ausgelegt sind, Ihre Geschäftsprozesse zu optimieren.',
      'profile.creditsRemainingShort': 'Credits verbleibend',
      'profile.refreshCredits': 'Credits aktualisieren',
      'profile.benefit1': 'Unbegrenzte Konvertierungen',
      'profile.benefit2': 'XRechnung, UBL, CII, & ZUGFeRD Support',
      'profile.benefit3': 'Erweiterte Funktionen',
      'profile.upgradePlan': 'Upgrade Ihres Plans',
      'profile.upgradePlanDesc': 'Erhalten Sie unbegrenzten Zugriff auf alle Funktionen mit unserem Premium-Plan.',
      'profile.usage': 'Ihre Nutzung',
      'profile.conversionsThisMonth': 'Konvertierungen diesen Monat',
      'profile.unlimited': 'Unbegrenzt',
      'profile.plan': 'Plan',
      'profile.premium': 'Premium',
      'profile.nextBillingDate': 'Nächstes Abrechnungsdatum',
      'profile.monthly': 'Monatlich',
  
      'auth.signin': 'Anmelden',
      'auth.signup': 'Registrieren',
      'auth.signingIn': 'Anmeldung läuft...',
      'auth.emailPlaceholder': 'E-Mail-Adresse',
      'auth.passwordPlaceholder': 'Passwort (mind. 6 Zeichen)',
      'auth.confirmPasswordPlaceholder': 'Passwort bestätigen',
      'auth.errors.passwordLength': 'Das Passwort muss mindestens 6 Zeichen lang sein',
      'auth.errors.invalidCredentials': 'Ungültige E-Mail oder Passwort',
      'auth.errors.generic': 'Anmeldung fehlgeschlagen',
      'auth.verificationSuccess': 'E-Mail-Verifizierung erfolgreich!',
      'auth.redirectingToSignIn': 'Weiterleitung zur Anmeldung...',
      'auth.processing': 'Authentifizierung wird verarbeitet...',
      'auth.tooManyRequests': 'Zu viele Anfragen. Bitte warten Sie einige Minuten, bevor Sie es erneut versuchen.',
      'auth.termsCheckbox': 'Ich akzeptiere die',
      'auth.termsRequired': 'Sie müssen die Allgemeinen Geschäftsbedingungen und Datenschutzerklärung akzeptieren, um sich zu registrieren',
      'auth.accountConsentNotice': 'Durch die Erstellung eines Kontos stimmen Sie zu, wichtige Service-Updates und relevante Marketing-Kommunikation zu erhalten. Sie können Marketing-E-Mails jederzeit abbestellen.',
      'auth.noAccount': 'Noch kein Konto?',
      'auth.haveAccount': 'Bereits ein Konto?',
      'auth.signingUp': 'Registrierung läuft...',
      'auth.resetPassword': 'Passwort zurücksetzen',
      'auth.forgotPassword': 'Ich habe mein Passwort vergessen',
      'auth.resetPasswordEmailSent': 'Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren',
      'auth.resetPasswordError': 'Fehler beim Senden der E-Mail zum Zurücksetzen des Passworts',
      'auth.sending': 'Senden...',
      'auth.sendResetLink': 'Reset-Link senden',
      'auth.backToSignIn': 'Zurück zur Anmeldung',
      'auth.updatePassword': 'Passwort aktualisieren',
      'auth.newPassword': 'Neues Passwort',
      'auth.passwordUpdateSuccess': 'Passwort erfolgreich aktualisiert!',
      'auth.passwordUpdateError': 'Fehler beim Aktualisieren des Passworts',
      'auth.updating': 'Aktualisiere...',
      'auth.verificationEmailSent': 'Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren',
      'auth.checkSpamFolder': 'Wenn Sie die E-Mail nicht sehen, überprüfen Sie bitte Ihren Spam-Ordner',
      'auth.passwordsDoNotMatch': 'Die Passwörter stimmen nicht überein',
      'auth.emailConfirmedPopup': 'Ihre E-Mail-Adresse wurde bestätigt! Sie können sich jetzt anmelden.',

      'errors.insufficientCreditsOrSubscription': 'Unzureichende Credits oder kein aktives Abonnement',
      'errors.creditDeductionFailed': 'Fehler beim Abziehen der Credits',
      'errors.creditPurchaseProcessingFailed': 'Fehler bei der Verarbeitung des Credit-Kaufs',
  
      // These were only present in the original DE section
      'credits': {
          'remaining': 'Verbleibende Konvertierungen: {{count}}',
          'buyMore': 'Weitere Konvertierungen kaufen',
          'oneTime': 'Einmalige Konvertierung',
          'oneTimeDesc': 'Eine Rechnung für nur 5€ konvertieren',
          'subscription': 'Unbegrenzte Konvertierungen',
          'subscriptionDesc': 'Unbegrenzt Rechnungen für 6,25€/Monat konvertieren',
          'purchaseSuccess': 'Vielen Dank für Ihren Kauf! Ihr Konvertierungsguthaben wurde hinzugefügt.',
          'noCredits': 'Sie haben keine Konvertierungen mehr übrig. Bitte kaufen Sie weitere, um fortzufahren.',
          'lowCredits': 'Sie haben noch {{count}} Konvertierung übrig. Erwägen Sie den Kauf weiterer Konvertierungen, um Unterbrechungen zu vermeiden.'
      },
    }
  };